import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { useEffect } from 'react';
import { useLazyGetTotalIdeasLeaderboardQuery } from '../../../redux/services/leaderboardsApi';
import LeaderboardTable from '../../molecules/LeaderboardTable';

const TotalIdeasLeaderboard = () => {
  const [fetchEntries, { data, isFetching }] =
    useLazyGetTotalIdeasLeaderboardQuery();
  useEffect(() => {
    fetchEntries();
  }, []);
  return (
    <Box>
      <Typography sx={{ typography: { xs: 'h6', sm: 'h4' } }} gutterBottom>
        Total ideas
      </Typography>
      {isFetching ? (
        <CircularProgress />
      ) : (
        <LeaderboardTable
          entries={data ?? []}
          emptyText="No ideas yet, be the first one!"
        />
      )}
    </Box>
  );
};

export default TotalIdeasLeaderboard;
